import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { SchemaSearchResponse } from '../../loyalty-model/schemas/models/schemas.model';
import { CountryCodes } from '../models/merchant.model';

export const SearchMerchantSchemas = createAction(
  '[Merchant: Create New]: Search Merchant Schemas',
);

export const SearchMerchantSchemasSuccess = createAction(
  '[Merchant: Create New]: Search Merchant Schemas Success',
  props<{ schemas: SchemaSearchResponse[] }>(),
);

export const SearchMerchantSchemasFailed = createAction(
  '[Merchant: Create New]: Search Merchant Schemas Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const CompanyNameChanged = createAction(
  '[Merchant: Create New]: Company Name Changed',
  props<{ companyName: string }>(),
);

export const VATNumberChanged = createAction(
  '[Merchant: Create New]: VAT Number Changed',
  props<{ vatNumber: string }>(),
);

export const FirstNameChanged = createAction(
  '[Merchant: Create New]: First Name Changed',
  props<{ firstName: string }>(),
);

export const LastNameChanged = createAction(
  '[Merchant: Create New]: Last Name Changed',
  props<{ lastName: string }>(),
);

export const EmailAddressChanged = createAction(
  '[Merchant: Create New]: Email Address Changed',
  props<{ email: string }>(),
);

export const MerchantAppUserChanged = createAction(
  '[Merchant: Create New]: Merchant App User Changed',
);

export const UserNameChanged = createAction(
  '[Merchant: Create New]: User Name Changed',
  props<{ userName: string }>(),
);

export const HasLoyaltyFlagChanged = createAction(
  '[Merchant: Create New]: Has Loyalty Flag Changed',
  props<{ hasLoyaltyFlag: boolean }>(),
);

export const SelectedSchemaChanged = createAction(
  '[Merchant: Create New]: Selected Schema Changed',
  props<{ selectedSchema: string }>(),
);

export const CountryCodeChanged = createAction(
  '[Merchant: Create New]: Country Code Changed',
  props<{ country: string }>(),
);

export const MobileChanged = createAction(
  '[Merchant: Create New]: Mobile Changed',
  props<{ mobile: string }>(),
);

export const CreateMerchant = createAction('[Merchant: Create New]: Create Merchant');

export const CreateMerchantSuccess = createAction(
  '[Merchant: Create New]: Create Merchant Success',
  props<{ res: any }>(),
);

export const CreateMerchantFailed = createAction(
  '[Merchant: Create New]: Create Merchant Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const CreatePlainMerchant = createAction('[Merchant: Create New]: Create Plain Merchant');

export const CreatePlainMerchantSuccess = createAction(
  '[Merchant: Create New]: Create Plain Merchant Success',
  props<{ res: any }>(),
);

export const CreatePlainMerchantFailed = createAction(
  '[Merchant: Create New]: Create Plain Merchant Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetCountryCodes = createAction('[Merchant: Create New]: Country Codes');

export const GetCountryCodesSuccess = createAction(
  '[Merchant: Create New]: Country Codes Success',
  props<{ countryCodes: CountryCodes[] }>(),
);

export const GetCountryCodesFailed = createAction(
  '[Merchant: Create New]: Country Codes Failed',
  props<{ error: HttpErrorResponse }>(),
);
